<template>
  <!-- 在这里添加公共头部 -->
  <div class="Header">
    <div>
      <ul class="menu">
        <li>
          <a :href="dashboard">
            <img src="../assets/common/img/sudoku.png" alt="主菜单">
          </a>
        </li>
        <li>{{serviceName}}</li>
      </ul>
      <ul class="menuList">
        <li v-for="(list, index) in menuList" @click.stop="addClass(index)" :class="{isShow: index === isShow}">
          <!--<router-link :to="list.link" v-text="list.name"></router-link>-->
          <router-link :to="list.value" v-text="list.internationalText"></router-link>
        </li>
      </ul>
      <ul class="iconList">
        <li>
          <router-link to="/">
            <img src="../assets/common/img/alt.png" alt="@">
          </router-link>
        </li>
        <li>
          <router-link to="/">
            <img src="../assets/common/img/set.png" alt="设置">
          </router-link>
        </li>
        <li>
          <router-link to="/">
            <img src="../assets/common/img/dialogue.png" alt="对话">
          </router-link>
        </li>
        <li>
          <router-link to="/">
            <img src="../assets/common/img/photograph.png" alt="对话">
          </router-link>
        </li>
        <li class="headerActive">
          <el-dropdown @command="handleCommand">
            <span class="el-dropdown-link">
              {{username}}<i class="el-icon-arrow-down el-icon-caret-bottom"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="logout">{{I18n.logout}}</el-dropdown-item>
              <!--<el-dropdown-item>Admin</el-dropdown-item>-->
            </el-dropdown-menu>
          </el-dropdown>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  import INTERFACE from '../interface'
  import globalConfig from '../config'
  export default {
    data () {
      return {
        serviceName: '',
        username: '',
        I18n: window.I18n,
        menuList: '',
        dashboard: window.localStorage.dashboardUrl,
        isShow: Number(sessionStorage.getItem('isShow'))
      }
    },
    // 监听路由name的变化
    watch: {
      name() {
        if (this.$route.name === 'CheckList') {
          this.isShow = 0;
        }
      }
    },
    computed: {
      // 计算 路由name
      name() {
        return this.$route.name;
      }
    },
    created() {
      INTERFACE.getHeaderList().then(data => {
        // this.menuList = data.data.menuList;
        this.menuList = data.data.grantedSubmenu
        this.serviceName = data.data.serviceName
      })
      this.username = globalConfig.getCookie('username')
    },
    methods: {
      addClass(index) {
        this.isShow = index;
        // 会话存储当前isShow  转换为json存储
        sessionStorage.setItem('isShow', JSON.stringify(this.isShow));
      },
      handleCommand(command) {
        if (command === 'logout') {
          INTERFACE.logout().then(data => {
            // 清空cookie 跳转到登录页
            globalConfig.clearCookie()
            window.location.href = window.localStorage.loginUrl
          });
        }
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  @import "../style/publicHeader.styl";
</style>



// WEBPACK FOOTER //
// src/components/PublicHeader.vue